import onboarding from './onboarding';

const rootSubscribe = (store) => () => {
  onboarding.subscriber.subscribe(store);
};

export default rootSubscribe;
